import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm, } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { LoadingButton } from '@mui/lab';
import { Box, Card, Grid, Stack, } from '@mui/material';
// routes
import { PATH_MASTERDATA } from '../../../routes/paths';
import { useSnackbar } from '../../../components/snackbar';
import FormProvider, {
  RHFSelect,
  RHFSwitch,
  RHFTextField,
} from '../../../components/hook-form';
// import userAPI from 'src/api/userAPI';
import siteAPI from 'src/api/siteAPI';

// ----------------------------------------------------------------------

SiteNewEditForm.propTypes = {
  isEdit: PropTypes.bool,
  currentSite: PropTypes.object,
};

export default function SiteNewEditForm({ isEdit = false, currentSite }) {
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    location: Yup.string(),
    is_active: Yup.boolean(),
    is_payroll: Yup.boolean(),
  });

  const defaultValues = useMemo(
    () => ({
      name: currentSite?.name || '',
      location: currentSite?.location || '',
      is_active: currentSite?.is_active || 0,
      is_payroll: currentSite?.is_payroll || 0,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentSite]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;


  useEffect(() => {
    if (isEdit && currentSite) {
      reset(defaultValues);
    }
    if (!isEdit) {
      reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, currentSite]);

  const onSubmit = async (data) => {
    try {

      if (isEdit) {
        await siteAPI.updateSite(currentSite.id, data);
        enqueueSnackbar('User updated successfully!');
      }
      // Jika create, buat user baru
      else {
        await siteAPI.createSite(data);
        enqueueSnackbar('User created successfully!');
      }

      reset();
      navigate(PATH_MASTERDATA.site);
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.response?.data?.message || 'Failed to save user', { variant: 'error' });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3} >
        <Grid item xs={12} md={10}>
          <Card sx={{ p: 3 }}>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <RHFTextField name="name" label="Name" />
              <RHFTextField name="location" label="Location" />
              <RHFSwitch defaultChecked name="is_active" label="Active Site" />
              <RHFSwitch defaultChecked name="is_payroll" label="2x Payroll Site" />
            </Box>

            <Stack alignItems="flex-end" sx={{ mt: 3 }}>
              <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                {!isEdit ? 'Create Site' : 'Save Changes'}
              </LoadingButton>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
